import React, { useState } from "react";
import {Paper, Table, TableBody, Box, Collapse, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography, IconButton, Button} from "@mui/material";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions"; 
import Chip from "@mui/material/Chip";
import { StyledTableCell, StyledTableRow } from "./Styles/TableAndCellStyles";
import { useNavigate } from 'react-router-dom'; // for navigation
import PaymentIcon from '@mui/icons-material/Payment';
import { useDispatch } from "react-redux";
import { setTenantPayment } from "state";
import { formatDateString } from "utilities/date";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import axios from "axios";
import { baseURL } from "services/API";
import moment from "moment";
import { withoutSymbolFormatter, currencyFormatter} from "utilities/currencyFormatter";


const LandlordTenantPaymentsTable = ({ paymentData, handleDeletePayment, handleEditPayment }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();
  const dispatch = useDispatch()

  // Payment method is now an object with name property

  const renderStatusPills = (status) => {
		switch (status) {
			case false:
				return <Chip variant="outlined" sx={{ backgroundColor: "#ffebeb", fontSize:"10px", fontWeight:700 }} label="INCOMPLETE" size="small" color="warning" />;
			case true:
				return <Chip variant="outlined" sx={{ backgroundColor: "#ebefff", fontSize:"10px", fontWeight:700 }} label="COMPLETE" size="small" color="primary" />;
		}
	};

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleShowReceipt = (periodPayment, individualPayment) => {
    // Pass both the period payment and the individual payment data
    const receiptData = {
      periodPayment: periodPayment,
      individualPayment: individualPayment
    };
    
    dispatch(setTenantPayment(receiptData));
    navigate(`/tenant-receipts`);
  }

  function DetailDropDown(props) {
    const { row, index } = props;
    const [open, setOpen] = useState(false);
    const [itemData, setItemData] = useState([]);

    const handleClickView = async (id) => {
      try {
        const response = await axios.get(
          `${baseURL}/tenants/completed_payments/payments_list?period_id=${id}`
        );
        setItemData(response.data.data);
      } catch (err) {}
    };

    const handleClickViewClose = async (e) => {};
    
    return (
      <>
        <StyledTableRow key={row.id}>
          <StyledTableCell align="left">{formatDateString(row.related_active_period.date_started)}</StyledTableCell>
          <StyledTableCell align="left">{formatDateString(row.related_active_period.date_ended)}</StyledTableCell>
          <StyledTableCell style={{ textAlign:"center" }}>
            <IconButton aria-label="expand row"  onClick={(e) => {   setOpen(!open);   handleClickView(row.related_active_period.id); }}> {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}</IconButton>
          </StyledTableCell>
          <StyledTableCell style={{ textAlign: "center" }}>
            {/* Removed the View Receipt button from period level */}
          </StyledTableCell>
        </StyledTableRow>
        <StyledTableRow key={row.id}>
          <StyledTableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: "10px 10px 10px 10px", width:"100%" }}>
                <Typography variant="h4" gutterBottom component="div"> Payment Details</Typography>
                {itemData ? 
                  <Box sx={{ display: "flex", flexDirection: "column", margin: "15px"  }}>
                    <Table stickyHeader aria-label="sticky table" maxHeight="100vh">
                    <TableHead>
                      <StyledTableRow>
                      <StyledTableCell style={{ minWidth: 50,padding: "6px 20px" }}>Payment Date</StyledTableCell>
                      <StyledTableCell style={{ minWidth: 150,padding: "6px 20px", textAlign: "center"  }}>Amount Paid</StyledTableCell>
                      <StyledTableCell style={{ minWidth: 50,padding: "6px 20px", textAlign: "center"  }}>Mode of Payment</StyledTableCell>
                      <StyledTableCell style={{ minWidth: 50,padding: "6px 20px", textAlign: "center"  }}>Narration</StyledTableCell>
                      <StyledTableCell style={{ minWidth: 80,padding: "6px 20px", textAlign: "center"  }}>Months Covered</StyledTableCell>
                      <StyledTableCell style={{ minWidth: 120,padding: "6px 20px", textAlign: "center"  }}>Next Payment Date</StyledTableCell>
                      <StyledTableCell style={{ minWidth: 50,padding: "6px 20px", textAlign: "center"  }}>Actions</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {itemData.length === 0 ? (
                      <StyledTableRow>
                        <StyledTableCell colSpan={7} style={{ textAlign: "center" }}>
                          <Typography variant="h5">No payments recorded</Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                      ) : (
                      itemData
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((individualPayment, index) => {
                        return (
                          <StyledTableRow key={individualPayment.id}>
                          <StyledTableCell style={{ padding: "6px 20px" }}>{moment(individualPayment.date_paid).format('LL')}</StyledTableCell>
                          <StyledTableCell style={{ padding: "6px 20px", textAlign: "center" }}>{withoutSymbolFormatter(parseFloat(individualPayment.amount))}</StyledTableCell>
                          <StyledTableCell style={{ padding: "6px 20px", textAlign: "center"  }}>{individualPayment.payment_method?.name || 'Unknown'}</StyledTableCell>
                          <StyledTableCell style={{ padding: "6px 20px", textAlign: "center" }}>
                            {individualPayment.has_security_deposit 
                              ? "Security Deposit" 
                              : individualPayment.is_balance_carried_forward_payment
                              ? "Balance Carried Forward"
                              : individualPayment.is_outstanding_balance_payment
                              ? "Outstanding Balance"
                              : `${individualPayment.related_month?.month || 'January'} ${individualPayment.related_month?.year || '2025'}`}
                          </StyledTableCell>
                          <StyledTableCell style={{ padding: "6px 20px", textAlign: "center" }}>
                            {individualPayment.months_covered != null ? individualPayment.months_covered : "—"}
                          </StyledTableCell>
                          <StyledTableCell style={{ padding: "6px 20px", textAlign: "center" }}>
                            {individualPayment.next_payment_date
                              ? moment(individualPayment.next_payment_date).format("LL")
                              : "—"}
                          </StyledTableCell>
                          <StyledTableCell style={{ padding: "6px 20px", textAlign: "center"  }}>
                            <Button
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            sx={{ color:"blue" }}
                            onClick={(e) => handleShowReceipt(row, individualPayment)}
                            >
                            <PaymentIcon color="blue" sx={{ mr: 1 }} />
                            View Receipt
                            </Button>
                          </StyledTableCell>
                          </StyledTableRow>
                        );
                        })
                      )}
                    </TableBody>
                    </Table>
                  </Box> : (
                    <Box sx={{ width:"100%", display:"flex", justifyContent:"center" }}>
                    <h4>Payment Details Loading.......</h4>
                    </Box>
                  )
                }

              </Box>
            </Collapse>
          </StyledTableCell>
        </StyledTableRow>
      </>
    );
  }

  return (
    <>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer>
          <Table>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="left">Month Start Date</StyledTableCell>
                <StyledTableCell align="left">Month End Date</StyledTableCell>
                <StyledTableCell align="center">Payments Made</StyledTableCell>
                <StyledTableCell align="left">Actions</StyledTableCell>
                </StyledTableRow>
            </TableHead>
            <TableBody>
              {(paymentData > 0 ? paymentData.slice(page * rowsPerPage,page * rowsPerPage + rowsPerPage) : paymentData ).map((payment, index) => (
                <DetailDropDown row={payment} index={index}/>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, { label: "All", value: -1 }]}
                  colSpan={7}
                  count={paymentData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};

export default LandlordTenantPaymentsTable;
